export function PromiseTimer(ms, data = null) {
  return new Promise(res => {
    setTimeout(() => {
      res(data);
    }, ms);
  });
}
